module.exports = __webpack_public_path__ + "img/foot_icon_1.5464050.png";